import Typography from '@mui/material/Typography';
//import ArrowRightIcon from '@mui/icons-material/ArrowRight';

export const TextStructSignal = () => {

return(
<div>
    
<Typography variant="h6" >


Near gene NEGR1 at chromosome band / location 1p31.1 a 45-kb deletion was identified. (NEGR1 encodes a cell-adhesion molecule expressed in the brain)
<br /> <br />
Deletions do not overlap with the coding sequence of NEGR1, but encompass a conserved transcription factor binding site for NKX6.1, a potent transcriptional repressor.
<br /> <br />
This structural variant may lead to increased risk of obesity.

 
</Typography>

</div>
)
}